import { Pagination } from 'shared/types/types';
import { TNewsEmployeeToSearch } from 'shared/types/news.types';
import { edpApiV1 } from './index';

export type GetEmployeesRequestModerator = {
  organizationId: string;
  divisionId?: string;
  search?: string;
  isActive: boolean;
  page: number;
  size: number;
  personnelNumber?: string;
};

export type GetEmployeesResponseModerator = {
  data: TNewsEmployeeToSearch[];
  pagination: {
    total: number;
    page: number;
    size: number;
  };
};

export type TDivisionResponse = { id: string; name: string };
export type TDivisionResponsePaginated = { data: TDivisionResponse[]; pagination: Pagination };
export type TDivisionRequest = { organizationId: string; search: string; page: number; size: number };

export type TOrganizationResponse = { id: string; name: string; isDemo: boolean };
export type TOrganizationResponsePaginated = { data: TOrganizationResponse[]; pagination: Pagination };
export type TOrganizationRequest = { search: string; page: number; size: number };

export const moderatorApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    getAdsEmployees: build.query<GetEmployeesResponseModerator, GetEmployeesRequestModerator>({
      query: params => ({ url: '/v1/moderator/ads/employee', method: 'GET', params }),
      providesTags: ['ads-employees'],
    }),
    getAdsDivisions: build.query<TDivisionResponsePaginated, TDivisionRequest>({
      query: params => ({ url: '/v1/moderator/ads/division', method: 'GET', params }),
      providesTags: ['ads-division'],
    }),
    getAdsOrganizations: build.query<TOrganizationResponsePaginated, TOrganizationRequest>({
      query: params => ({ url: '/v1/moderator/ads/organizations', method: 'GET', params }),
      providesTags: ['ads-organization'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAdsEmployeesQuery,
  useLazyGetAdsEmployeesQuery,
  useGetAdsOrganizationsQuery,
  useLazyGetAdsOrganizationsQuery,
  useGetAdsDivisionsQuery,
  useLazyGetAdsDivisionsQuery,
} = moderatorApi;
